import React from 'react'
import { FormattedMessage } from 'react-intl'

// The set of locale chips the LanguageMenu surfaces. Names are wrapped
// in FormattedMessage so they translate themselves when the user
// switches locale (Spanish-speaker sees "Español" while reading the
// French UI, etc.). Native-script labels remain when the catalog is
// missing a translation, courtesy of `defaultMessage`.
export const languages = [
  {
    locale: 'en',
    name: <FormattedMessage id="language.en" defaultMessage="English" />,
  },
  {
    locale: 'id',
    name: <FormattedMessage id="language.id" defaultMessage="Bahasa Indonesia" />,
  },
]

export default languages
